<!-- 水泵节能 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm" ref="handleForm">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="选择年份">
                    <el-date-picker
                        v-model="form.time"
                        type="year"
                        placeholder="选择年"
                        value-format="yyyy"
                        @change="choseTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button type="primary"><router-link to="/EnergyPumpDay">查看日报</router-link></el-button>
					<el-button type="primary" @click="onSubmitin">导出报表</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-card class="box-card onlyenergypump" shadow="never">
            <div slot="header" class="clearfix">
                <span>报表总览{{energypump_month}}</span>
            </div>
            <div class="energy-box">
                <ul class="situation-list">
                    <li class="situation-flex">
                        <span>总节约电费：{{energy_conservation_fee}} 元</span>
                        <span>总电费：{{sum_electricity_fee}} 元</span>
                        <span>总分成费用：{{pumps_divided_proportion_fee}} 元</span>
                    </li>
                </ul>
            </div>
        </el-card>
        <div style="height:20px;"></div>
        <div class="charts-box" >
            <div id="charts"  style="width: 100%;height:100%;"></div>
            <div class="nodata" v-show="charts_data.length===0">
                --  暂无数据 --
            </div>
        </div>
		<el-dialog 
		:title="titlename"
        :visible.sync="showdown"
		:before-close="handleCloseDialog"
		>
		<el-form>
			<el-form-item label="选择时间">
					<el-date-picker
					v-model="choseplctime"
					type="monthrange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM"
					@blur="choseplcTime"
					>
					</el-date-picker>
			 </el-form-item>
			 <el-form-item label="PLC设备">
			     <el-select v-model="plcform.terminal_id" placeholder="请选择设备" >
			         <el-option
			             v-for="item in deviceList"
			             :key="item.oid"
			             :label="item.customized_serial+'：'+item.terminal_serial"
			             :value="item.oid">
			         </el-option>
			     </el-select>
			 </el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleCloseDialog">取 消</el-button>
			<el-button type="primary" @click="down">确 定</el-button>
		</div>
		</el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import echarts from "echarts"
import Service from '@/api/Service'
import { FormatDate, FormatDateDay,FormatPrevDate} from '@/utils/utils.js'
import config from '@/config.js'

const nowDay = FormatDate("yyyy-MM");
const prevDay = FormatPrevDate("yyyy-MM");
// 节能概况
    const mockData = [
        {
            name: '总节约电费',
            type: 'bar',
            data: [120, 132, 101, 110, 90, 111, 123]
        },
        {
            name: '总电费',
            type: 'bar',
            data: [555, 600, 400, 700, 588, 567, 444, 700, 588, 567, 444, 444]
        }
    ]

    var chart1 = null
export default {
    name:  'energypump',
    data() {
        return {
            form: {
                month: '',
                time: FormatDate('yyyy-MM-dd HH:mm:ss')
            },
			plcform:{
				project_sys_id:'',
				terminal_id:'',
				bill_type:"shuibeng",
				from:nowDay,
				to:prevDay,
			},
			titlename:'导出报表',
			showdown:false,
			choseplctime:'',
			deviceList:[],
            month: new Date().getMonth()+1,

            charts_data: mockData,
			energypump_month:null,
            energy_conservation: [], // 总节约电费
            energy_pump: [],    //  水泵总电费

            energy_conservation_data: 0, // 总节约电费
            energy_pump_data: 0,    //  水泵节约电费

            energy_pump_data1: 0,    //  水泵节约电量
            energy_pump_totle: 0,    //  水泵总电量

            energy_conservation_use: 0,
            sum_electricity_fee: 0,
            energy_conservation_fee: 0,
            pumps_divided_proportion_fee: 0,
        };
    },

    components: {},

    computed: {},

    mounted() {
        this.$nextTick(()=>{

            // 基于准备好的dom，初始化echarts实例
            chart1 = echarts.init(document.getElementById('charts'));

            let time = FormatDate('yyyy-MM-dd HH:mm:ss')
            this.getEnergyConservation(time)
            this.getPumpEnergyDetail(time)
        })
		this.getDeviceList()
    },

    methods: {
		//导出报表
		onSubmitin(){
			this.showdown=true
		},
		handleCloseDialog(){
			this.showdown=false
		},
		choseplcTime(val){
			this.plcform.from = val.value[0]
			this.plcform.to = val.value[1]
		},
        // 获取全部PLC
        async getDeviceList() {
            let params = Object.assign({}, { page_num: 1, page_sum: 40 });
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                this.terminal_id = list[0].oid   
            }
        },
		//下载报表
		async down(){
			let res = await Service.getExport(this.plcform)
			if(res){
				if(res) {
						location.href = config.DEFAULT_FILE_PATH + res
				 }
				this.showdown = false;
			}
		},
        async getEnergyConservation(time) {
            let res = await Service.getPumpStatisticByPIDTimeRange({time_range: "month", time});
            if(res) {
                let electricity_fee = res.electricity_fee
                // 水泵总节约电费   electricity_fee.conservation_electricity_fee
                if(electricity_fee.conservation_electricity_fee && electricity_fee.conservation_electricity_fee.length>0) {
                    this.energy_conservation = electricity_fee.conservation_electricity_fee.map(v=>{
                        return v.value
                    })
                }else{
					this.energy_conservation = []
				}
                // 水泵总电费   electricity_fee.sum_electricity_fee
                if(electricity_fee.sum_electricity_fee && electricity_fee.sum_electricity_fee.length>0) {
                    this.energy_pump = electricity_fee.sum_electricity_fee.map(v=>{
                        return v.value
                    })
                }else{
					this.energy_pump = []
				}
            }
            this.initData()
        },
        async getPumpEnergyDetail(time) {
            let month = this.month
            let time_range = 'month'
            let res = await Service.getPumpsConservationByPIDMonthRange({month, time_range,time})
            if(res) {
                // this.energy_conservation_use = res.electricity_statistic.energy_conservation
                this.sum_electricity_fee = res.fee_statistic.sum_electricity_fee.toFixed(2)
                this.energy_conservation_fee = res.fee_statistic.energy_conservation_fee.toFixed(2)
                this.pumps_divided_proportion_fee = res.fee_statistic.pumps_divided_proportion_fee.toFixed(2)
            }
        },
        choseTime(val) {
            if(!val) return
			const newval = val.toString() + "-12-31 23:59:59"
            this.form.time = newval
            // this.form.time = val
        },
        // 查询
        onSubmit() {
            let time = this.form.time
			this.month = 12
			this.getPumpEnergyDetail(time)
            this.getEnergyConservation(time);
			
        },
        initData() {
            this.initChart1(this.energy_conservation, this.energy_pump)
        },
        initChart1(nowDay, otherDay) {
            let option = this.getOption();
            option.series =  [
                {
                    name: '总节约电费',
                    type: 'bar',
                    stack: '电费',
                    data: nowDay,
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(56, 191, 96, 1)'
                        
                    },
                },
                {
                    name: '总电费',
                    type: 'bar',
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(196, 178, 27, 1)'
                    },
                    data: otherDay,
                },
            ]
            chart1.setOption(option);

            let that = this
            chart1.on('click',(params)=>{
                if(params.seriesType === 'bar') {
                    that.month = params.dataIndex+1
					let time = this.form.time
					that.energypump_month = ':'+ that.month + '月份',
                    that.getPumpEnergyDetail(time);
                }
            });
        },
        getOption() {
            return {
                tooltip: {
                    trigger: 'axis',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    axisPointer: {
                        type: 'cross',
                    }
                },
                legend: {
                    data: ['总节约电费', '总电费'],
                    right: 160,
                    top: 10,
                },
                grid: {
                    left: 70,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },
                
                xAxis: [
                    {
                        type: 'category',
                        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        name: '元',
                    }
                ],
                series: [
                    {
                        name: '总节约电费',
                        type: 'bar',
                        stack: '电费',
                        data: [],
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(196, 178, 27, 1)'
                        },
                    },
                    {
                        name: '总电费',
                        type: 'bar',
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(56, 191, 96, 1)'
                        },
                        data: [],
                    },
                ],
            }
        }
    }
}

</script>
<style lang='less' scoped>
    .situation-list{
        margin: 10px;
        .situation-flex{
            // border-bottom: 1px solid #EBEEF5;
            display: flex;
            flex-direction: row;
            span{
                flex: 1;
                text-align: left;
                font-size: 14px;
                color: #666;
                line-height: 40px;
                margin: 10px 0;
                text-align: left;
                padding: 0 20px;
                &:nth-child(2){
                    border-left: 1px solid #EBEEF5;
                    border-right: 1px solid #EBEEF5;
                }
            }
        }
    }

    .charts-box{
        height: 400px;
    }
</style>
<style lang='less'>
	.onlyenergypump .el-card__header{
		background: rgb(41, 61, 110);
		color: #FFFFFF;
		text-align:center;
	}	
</style>